import React from 'react';
import { CheckIcon, ClipboardCheckIcon, PhoneIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
const reviewItems = ['Patient population', 'Staff workflow', 'Training and rollout'];
export function WelcomeVideo() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-269" data-mp="3604q4mqs8s4">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-270" data-mp="3vd6lw3347855">
        <div data-id="element-271" data-mp="37n2le4l83oid">
          <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-272" data-mp="37mst2acph59i">
            BEFORE YOU BUY
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-273" data-mp="3geuuobyigrld">
            Start With the Fit, Not the Catalog
          </h2>
          <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-charcoal/75" data-id="element-274" data-mp="3bmbf59g9jmdx">
            A quick conversation can help a practice avoid investing in
            technology that does not match its patients, workflow, budget, or
            training capacity. JAG Medical Solutions helps doctors compare
            modalities, understand implementation needs, and choose equipment
            with a clear plan for adoption.
          </p>
          <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-275" data-mp="aiq3j98fyicu">
            <PhoneIcon className="h-[18px] w-[18px]" data-id="element-276" data-mp="3izbbcmpc75ed" />
            Call Before You Buy
          </a>
        </div>
        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-6 shadow-[0_24px_60px_-24px_rgba(26,27,75,0.24)] sm:p-8" data-id="element-277" data-mp="3nzz2r9hh9o94">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-278" data-mp="137x8apyho46j">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-teal/10 text-teal" data-id="element-279" data-mp="186qdzw7jaqw5">
              <ClipboardCheckIcon className="h-6 w-6" data-id="element-280" data-mp="349mptc74znra" />
            </span>
            <h3 className="mt-6 font-display text-xl font-bold text-navy" data-id="element-281" data-mp="34bzfkbj4z2ew">
              Practice-fit review
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-282" data-mp="3dab5ebc6hw6a">
              {reviewItems.map(item => <li key={item} className="flex items-center gap-3 text-sm font-medium text-charcoal" data-id="element-283" data-mp="398znkrzjqf8n">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/10 text-teal" data-id="element-284" data-mp="2ljetbcxxzvk2">
                    <CheckIcon className="h-3.5 w-3.5" data-id="element-285" data-mp="2gl3hiwo37az7" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}